import Vue from 'vue';
import components from '../components/typo3-library-overrides/Index';

// @ts-ignore
export default ({ app }) => {
  Object.keys(components).forEach((key) => {
    // @ts-ignore
    Vue.component(key, components[key]);
    // @ts-ignore
    app.components[key] = components[key];
  });
};
